import {
  AdminLoginData,
  AdminLoginResponse,
  toAdminLoginPostReqDTO,
  toAdminLoginResponse,
} from "../model/admin";
import { AdminLoginPostResDTO } from "./admin-dto";
import { getApiClient } from "../../../shared/api/client.api";
import { CommonResponseDto } from "../../../shared/api/common-response.dto";

/**
 * Admin API 클라이언트
 * Admin 관련 API 호출을 담당
 */
export const manageAdminApi = (() => {
  const apiClient = getApiClient();

  const login = async (
    adminData: AdminLoginData,
  ): Promise<AdminLoginResponse> => {
    try {
      const payload = toAdminLoginPostReqDTO(adminData);
      const response = await apiClient.post<
        CommonResponseDto<AdminLoginPostResDTO>
      >("/login", payload);

      if (!response.data.success || !response.data.data) {
        throw new Error(response.data.error?.details || "Login failed");
      }

      return toAdminLoginResponse(response.data.data);
    } catch (error) {
      console.error("Failed to login:", error);
      throw error;
    }
  };

  const verifyToken = async (): Promise<{ valid: boolean; user?: any }> => {
    try {
      const response = await apiClient.get<
        CommonResponseDto<{
          valid: boolean;
          user: any;
        }>
      >("/verify-token");

      if (!response.data.success || !response.data.data) {
        return { valid: false };
      }

      return response.data.data;
    } catch (error) {
      console.error("Failed to verify token:", error);
      return { valid: false };
    }
  };

  const logout = async (): Promise<CommonResponseDto<void>> => {
    try {
      const response =
        await apiClient.post<CommonResponseDto<void>>("/admin/logout");

      if (!response.data.success) {
        throw new Error(response.data.error?.details || "Logout failed");
      }

      return response.data;
    } catch (error) {
      console.error("Failed to logout:", error);
      throw error;
    }
  };

  return {
    login,
    verifyToken,
    logout,
  };
})();
